import { render, staticRenderFns } from "./DocsGithubLink.vue?vue&type=template&id=1f810eba&scoped=true"
import script from "./DocsGithubLink.vue?vue&type=script&lang=js"
export * from "./DocsGithubLink.vue?vue&type=script&lang=js"
import style0 from "./DocsGithubLink.vue?vue&type=style&index=0&id=1f810eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f810eba",
  null
  
)

export default component.exports